import { Link } from "react-router-dom";
import ServiceLayout, { ContentSection } from "@/components/site/ServiceLayout";
import { Reveal, TickList } from "@/components/site/Reveal";

const OFFERS = [
  "Guidance and feedback from an experienced practitioner",
  "A safe space to explore cases, challenges and personal reactions",
  "Support to enhance your clinical skills",
  "Help navigating ethical dilemmas",
  "Room for self-reflection and professional growth",
];

const FORMATS = [
  {
    title: "Individual supervision",
    text: "One-to-one sessions tailored entirely to your caseload, questions and professional goals.",
  },
  {
    title: "Group supervision",
    text: "Learn alongside peers — shared reflection, diverse perspectives and mutual support.",
  },
];

export default function ClinicalSupervision() {
  return (
    <ServiceLayout
      eyebrow="For professionals"
      title="Clinical Supervision"
      lead="Are you a social worker seeking professional growth and support? Eucalypt Therapy offers clinical supervision tailored to your needs."
      image="https://images.unsplash.com/photo-1611255550543-b5ecb01dfddc?crop=entropy&cs=srgb&fm=jpg&q=85"
      imageAlt="Eucalyptus leaves in gentle light"
    >
      <ContentSection eyebrow="What supervision offers" title="A space to grow your practice">
        <Reveal>
          <p className="max-w-3xl text-base sm:text-lg leading-relaxed text-mutedsoft">
            With extensive experience and expertise in social work practice, Eucalypt Therapy provides guidance,
            feedback and a safe space for you to explore cases, challenges and personal reactions. Together, we
            will enhance your clinical skills, navigate ethical dilemmas and foster self-reflection.
          </p>
        </Reveal>
        <div className="mt-10">
          <TickList items={OFFERS} />
        </div>
      </ContentSection>

      <ContentSection eyebrow="Formats" title="Individual or group" pale>
        <div className="grid gap-6 sm:grid-cols-2">
          {FORMATS.map((f, i) => (
            <Reveal key={f.title} delay={i * 0.08}>
              <div className="h-full rounded-2xl border border-euca-line bg-white p-7 shadow-sm">
                <span className="font-serif text-3xl italic text-euca-sage/70">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="mt-4 font-serif text-xl font-medium text-euca-dark">{f.title}</h3>
                <p className="mt-2 text-base leading-relaxed text-mutedsoft">{f.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.15}>
          <p className="mt-10 max-w-3xl text-base leading-relaxed text-mutedsoft">
            Whether through individual or group supervision, Eucalypt Therapy is committed to your professional
            development and well-being. We are proud members of the{" "}
            <span className="font-semibold text-charcoal">Australian Association of Social Workers (AASW)</span>.
          </p>
        </Reveal>
      </ContentSection>

      <ContentSection eyebrow="Get started" title="Arrange supervision">
        <Reveal>
          <p className="max-w-3xl text-base leading-relaxed text-mutedsoft">
            Supervision is <span className="font-semibold text-charcoal">$220 per session (GST inclusive)</span>,
            individually or in groups —{" "}
            <Link to="/contact?service=referral" className="font-semibold text-euca hover:underline" data-testid="supervision-enquiry">
              send an enquiry
            </Link>{" "}
            with a little about your practice and what you are looking for, and we will be in touch.
          </p>
        </Reveal>
      </ContentSection>
    </ServiceLayout>
  );
}
